import { EmailIntakeQueueRepository } from '../repositories/EmailIntakeQueueRepository';
import {
  EmailIntakeQueueResultEntity,
  EmailStatus,
  EmailCategory,
} from '../entities/EmailIntakeQueueEntity';

/**
 * Get Emails Use Case
 * Retrieves emails with optional filtering, pagination, and sorting
 */
export class GetEmailsUseCase {
  constructor(private repository: EmailIntakeQueueRepository) {}

  async execute(params?: {
    status?: EmailStatus;
    category?: EmailCategory;
    subdomain?: string;
    search?: string;
    reason?: string;
    limit?: number;
    offset?: number;
    sort_by?: 'created_at' | 'received_at' | 'updated_at';
    sort_order?: 'asc' | 'desc';
  }): Promise<EmailIntakeQueueResultEntity> {
    // Validate limit if provided
    if (params?.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error('Limit must be between 1 and 100');
    }

    // Validate offset if provided
    if (params?.offset !== undefined && params.offset < 0) {
      throw new Error('Offset must be 0 or greater');
    }

    return await this.repository.fetchEmails(params);
  }
}

